<cwc-page #layoutPage [ngClass]="{ 'cwc-page-container': actionBarPortal }" (cwcScroll)="onScroll($event)">
  <arkik-global-header
    slot="header"
    [isDarkMode]="isDarkMode"
    [isDarkModeEnabled]="isDarkModeEnabled"
    [logo]="Logo"
    [logoDark]="LogoDark"
    [applicationMenus]="responseMenusUser?.applicationMenus"
    [FullName]="fullName"
    [imagePath]="imagePath"
    [Email]="email"
    [languages]="languages"
    (signOut)="SignOut()"
    (openAppInterface)="appInterfaceSelected($event)"
    (languageChange)="changeLanguage($event)"
    (darkModeChange)="changeDarkMode($event)"
  ></arkik-global-header>

  <cwc-sidenav slot="sidenav" variant="positive" [open]="openMenu" (collapsed)="changeCollapseSidebar($event)">
    <cwc-sidenav-menu id="menuNav" slot="menu-items" variant="positive" [collapsed]="!openMenu">
      <ng-container *ngFor="let item of applicationMenu?.modules; let i = index">
        <ng-container *ngIf="item && languageCode && item.active && !(item.isQuickLink || item.isReportHub)">
          <ng-container *ngIf="!isUnavailableOffline(item)">
            <div [class.bom-menu-badge-wrapper]="isBackorderManagementItem(item)">
              <cwc-sidenav-menu-item
                id="{{ item.moduleGuid }}"
                [active]="item.isActiveRoute"
                [label]="item.translation"
                [iconName]="item.icon"
                class="positive v2"
                variant="positive"
                (cwcClick)="mouseDownModule(item, $event)"
                [class.inactive]="router.url.includes('/orders/order-taking/') || menuItemsDisabled"
                [collapsed]="!openMenu"
                [style.animationDelay]="i * FADE_IN_DELAY + 'ms'"
              >
                <ng-container *ngFor="let itemLevel2 of item.children">
                  <ng-container *ngIf="itemLevel2 && languageCode && itemLevel2.active && item?.showChildrenSideMenu">
                    <cwc-sidenav-menu-item
                      id="{{ itemLevel2.moduleGuid }}"
                      class="positive v2"
                      variant="positive"
                      (cwcClick)="mouseDownModule(itemLevel2, $event)"
                      [label]="itemLevel2.translation"
                      [collapsed]="!openMenu"
                      [active]="itemLevel2.isActiveRoute"
                    >
                      <ng-container *ngFor="let itemLevel3 of itemLevel2.children">
                        <ng-container
                          *ngIf="itemLevel3 && languageCode && itemLevel3.active && itemLevel2?.showChildrenSideMenu"
                        >
                          <cwc-sidenav-menu-item
                            id="{{ itemLevel3.moduleGuid }}"
                            class="positive v2"
                            variant="positive"
                            (cwcClick)="mouseDownModule(itemLevel3, $event)"
                            [label]="itemLevel3.translation"
                            [collapsed]="!openMenu"
                            [active]="itemLevel3.isActiveRoute"
                          ></cwc-sidenav-menu-item>
                        </ng-container>
                      </ng-container>
                    </cwc-sidenav-menu-item>
                  </ng-container>
                </ng-container>
              </cwc-sidenav-menu-item>
              <span
                *ngIf="isBackorderManagementItem(item) && (bomBadgeLabel$ | async) as badge"
                class="bom-menu-badge"
                >{{ badge }}</span
              >
            </div>
          </ng-container>

          <ng-container *ngIf="isUnavailableOffline(item)">
            <cwc-tooltip
              content="{{ 'views.globals.offline.option-unavailable' | translate }}"
              position="right"
              [disabled]="true"
            >
              <cwc-sidenav-menu-item
                id="{{ item.moduleGuid }}"
                [active]="item.isActiveRoute"
                [label]="item.translation"
                [iconName]="item.icon"
                class="positive v2 fade-in-top"
                variant="positive"
                (cwcClick)="mouseDownModule(item, $event)"
                [collapsed]="!openMenu"
                [class.inactive]="true"
                [style.animationDelay]="i * FADE_IN_DELAY + 'ms'"
              ></cwc-sidenav-menu-item>
            </cwc-tooltip>
          </ng-container>
        </ng-container>
      </ng-container>
    </cwc-sidenav-menu>

    <cwc-footer-menu *ngIf="showLinks" slot="links" variant="positive">
      <cwc-footer-menu-item label="Terms & Conditions" href="terms" target="_blank"></cwc-footer-menu-item>
      <cwc-footer-menu-item label="Privacy Policy" href="privacy" target="_blank"></cwc-footer-menu-item>
    </cwc-footer-menu>

    <div slot="copyright">
      {{
        (!showLinks ? 'views.globals.copyright.year' : 'views.globals.copyrightArkik.year')
          | translate: [today | date: 'yyyy']
      }}
      <br />
      {{ (!showLinks ? 'views.globals.copyright.label' : 'views.globals.copyrightArkik.label') | translate }}
    </div>
    <div>
      <a href="" target="_blank" id="hyperlinkExternalUrl" title="" aria-label="Hyperlink to external URL"></a>
    </div>
  </cwc-sidenav>

  <div slot="main" class="layout-main" [ngClass]="{ 'action-bar-active': forceActionBarLayout }">
    <div #alertHost class="alert-host"></div>
    <section
      class="main-config"
      [ngClass]="{
        'table-mode': tableActive | async,
        'action-bar-active': actionBarPortal,
        'remove-padding': removePadding$ | async
      }"
    >
      <router-outlet></router-outlet>
    </section>
    <div class="action-bar-container action-bar-sticky" *ngIf="actionBarPortal">
      <ng-template [cdkPortalOutlet]="actionBarPortal"></ng-template>
    </div>
  </div>
</cwc-page>

<ng-template #modalAlert>
  <cwc-modal [open]="showAlert" overlayZIndex="999999" fullWidthResponsive="true" (cwcClose)="closeAlert()">
    <div class="t-center">
      <cwc-icon [name]="iconAlert" size="120px" [color]="colorIconAlert"></cwc-icon>
      <h3 class="modal--confirmation__message">{{ msgAlert }}</h3>
    </div>
    <footer slot="footer" class="footer">
      <div class="text-right">
        <cwc-button variant="support" (cwcClick)="closeAlert()" class="m-r-16">
          {{ cancelButtonText }}
        </cwc-button>
        <cwc-button variant="primary" (cwcClick)="confirmActionModal()">
          {{ confirmButtonText }}
        </cwc-button>
      </div>
    </footer>
  </cwc-modal>
</ng-template>
